import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  Popconfirm,
  Space,
  Card,
} from 'antd';
import {
  PlusOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { getOrderItemDetails } from '../../../network/purchaseOrder';
import { useMutation } from '@tanstack/react-query';
import { MdEdit } from 'react-icons/md';
import { BiSolidShow } from 'react-icons/bi';
import { ModalAppItemDetails } from '../ModalApp/ModalApp';
const PaymentSchedule = ({
  setDataSourcePayment,
  dataSourcePayment,
  t,
  form,
  type,
  view,
}) => {
  console.log('dataSourcePayment', dataSourcePayment);
  const [selectData, setSelectData] = useState({});

  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);
  const columns = [
    {
      title: t.dueDate,
      dataIndex: 'due_date',
      render: (text, record, index) => (
        <DatePicker
          placeholder={t.dueDate}
          format="YYYY-MM-DD"
          style={{ width: '100%' }}
          value={record.due_date ? dayjs(record.due_date) : null}
          disabled={view}
          onChange={(date) => {
            const newDataSource = [...dataSourcePayment];
            newDataSource[index] = {
              ...newDataSource[index],
              due_date: date,
            };
            setDataSourcePayment(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.invoicePortion,
      dataIndex: 'invoice_portion',
      render: (text, record, index) => (
        <Input
          placeholder={t.invoicePortion}
          style={{ width: '100%' }}
          type="number"
          min={0}
          disabled={view}
          value={record.invoice_portion}
          onChange={(e) => {
            const newDataSource = [...dataSourcePayment];
            newDataSource[index] = {
              ...newDataSource[index],
              invoice_portion: e.target.value,
            };
            setDataSourcePayment(newDataSource);
          }}
        />
      ),
    },
    {
      // hidden: type === 'invoice' ? false : true,
      hidden: true,
      title: t.discountType,
      dataIndex: 'discount_type',
      render: (text, record, index) => (
        <Select
          placeholder={t.discountType}
          value={record.discount_type}
          disabled={view}
          onChange={(value) => {
            const newDataSource = [...dataSourcePayment];
            newDataSource[index] = {
              ...newDataSource[index],
              discount_type: value,
            };
            setDataSourcePayment(newDataSource);
          }}
          style={{ width: '100%' }}
          options={[
            {
              value: 'Percentage',
              label: t.percentage,
            },
            {
              value: 'Amount',
              label: t.amount,
            },
          ]}
        />
      ),
    },
    {
      hidden: true,
      title: t.discount,
      dataIndex: 'discount',
      render: (text, record, index) => (
        <Input
          placeholder={t.discount}
          style={{ width: '100%' }}
          type="number"
          min={0}
          step="0.01"
          value={record.discount}
          disabled={view}
          onChange={(e) => {
            const newDataSource = [...dataSourcePayment];
            newDataSource[index] = {
              ...newDataSource[index],
              discount: e.target.value,
            };
            setDataSourcePayment(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.paymentAmount,
      dataIndex: 'payment_amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.paymentAmount}
          style={{ width: '100%' }}
          type="number"
          min={0}
          step="0.01"
          value={record.payment_amount}
          disabled={type === 'sales' ? false : true}
          onChange={(e) => {
            const newDataSource = [...dataSourcePayment];
            newDataSource[index] = {
              ...newDataSource[index],
              payment_amount: e.target.value,
            };
            setDataSourcePayment(newDataSource);
          }}
        />
      ),
    },
    {
      hidden: true,
      title: t.outstanding,
      dataIndex: 'outstanding',
      render: (text, record, index) => (
        <Input
          placeholder={t.outstanding}
          style={{ width: '100%' }}
          type="number"
          min={0}
          step="0.01"
          value={record.outstanding}
          disabled={view}
          onChange={(e) => {
            const newDataSource = [...dataSourcePayment];
            newDataSource[index] = {
              ...newDataSource[index],
              outstanding: e.target.value,
            };
            setDataSourcePayment(newDataSource);
          }}
        />
      ),
    },
    {
      hidden: true,
      title: t.paidAmount,
      dataIndex: 'paid_amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.paidAmount}
          style={{ width: '100%' }}
          type="number"
          min={0}
          step="0.01"
          value={record.paid_amount}
          disabled={view}
          onChange={(e) => {
            const newDataSource = [...dataSourcePayment];
            newDataSource[index] = {
              ...newDataSource[index],
              paid_amount: e.target.value,
            };
            setDataSourcePayment(newDataSource);
          }}
        />
      ),
    },
    {
      //   hidden: type === 'Order' ? false : true,
      hidden: true,
      title: t.discountedAmount,
      dataIndex: 'discounted_amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.discountedAmount}
          style={{ width: '100%' }}
          type="number"
          min={0}
          step="0.01"
          value={record.discounted_amount}
          disabled={view}
          onChange={(e) => {
            const newDataSource = [...dataSourcePayment];
            newDataSource[index] = {
              ...newDataSource[index],
              discounted_amount: e.target.value,
            };
            setDataSourcePayment(newDataSource);
          }}
        />
      ),
    },
    {
      //   hidden: type === 'Order' ? false : true,
      hidden: true,
      title: t.basePaymentAmount,
      dataIndex: 'base_payment_amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.basePaymentAmount}
          style={{ width: '100%' }}
          type="number"
          min={0}
          step="0.01"
          value={record.base_payment_amount}
          disabled={view}
          onChange={(e) => {
            const newDataSource = [...dataSourcePayment];
            newDataSource[index] = {
              ...newDataSource[index],
              base_payment_amount: e.target.value,
            };
            setDataSourcePayment(newDataSource);
          }}
        />
      ),
    },
    {
      //   hidden: type === '' ? false : true,
      title: t.description,
      dataIndex: 'description',
      render: (text, record, index) => (
        <Input
          placeholder={t.description}
          style={{ width: '100%' }}
          value={record.description}
          disabled={view}
          onChange={(e) => {
            const newDataSource = [...dataSourcePayment];
            newDataSource[index] = {
              ...newDataSource[index],
              description: e.target.value,
            };
            setDataSourcePayment(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          {/* <Button
          type="primary"
          // icon={<MdEdit />}
          icon={<BiSolidShow />}
          size='small'
          onClick={() => handleDetails(record.key)}
        /> */}
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      due_date: dayjs(),
      invoice_portion: 100,
    };
    setDataSourcePayment([...dataSourcePayment, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSourcePayment.filter((item) => item.key !== key);
    setDataSourcePayment(newDataSource);
  };

  const handleDetails = (key) => {
    console.log('dataSourcePayment', dataSourcePayment);
    const row = dataSourcePayment.find((item) => item.key === key);
    if (row) {
      setSelectData({
        ...row,
        due_date: dayjs(row.due_date).format('YYYY-MM-DD'),
      });
      setOpen(true);
      console.log('Row details:', row);
    }
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSourcePayment}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
      {/* <ModalAppItemDetails open={open} setOpen={setOpen} t={t} selectData={selectData} /> */}
    </Card>
  );
};

export default PaymentSchedule;
